import axiosInstance from "../instance";

// Get All Categories
const fetchCodes = async () => {
    const response = await axiosInstance.get('/discount-codes');
    return response.data;
}

const addCode = async (newCode) => {
    const response = await axiosInstance.post('/discount-codes', newCode);
    return response.data;
}

const updateCode = async (newCode) => {
    const response = await axiosInstance.patch(`/discount-codes/${newCode.codeId}`, {
        code: newCode.code,
        discount: newCode.discount
    });
    return response.data;
}

const deleteCode = async (codeId) => {
    const response = await axiosInstance.delete(`/discount-codes/${codeId}`);
    return response.data;
}

export { fetchCodes, addCode, updateCode, deleteCode };
